<template>
<div>	
	<expense-table
		:heading="'Expenses for '+$store.employee.first_name+' '+$store.employee.last_name"
		:show-user="false"
		:show-job="true"
		:editable="true"
		:filtering-tools="true"
		:filters="[
			['user_id',$store.employee.id]
		]">
	</expense-table>
</div>
</template>

<script>

import ExpenseTable from "../../../components/super_components/ExpenseTable"

export default {

	name: 'EmployeeExpenses',
	components: {
		ExpenseTable
	}

}
</script>
